// extracted by mini-css-extract-plugin
export default {"ActionList_Description":"MarkdownEditHistoryViewer-module__ActionList_Description--Z9ggs"};